import { Tooltip } from '@material-ui/core'
import { head, last } from '@soltalabs/ramda-extra'
import moment from 'moment'
import React from 'react'

import { deepMemo } from '../../../utils/react'

import { StyledSlider, StyledLinearProgress } from './styles'

const sliderValueText = (time) => {
  return moment.unix(time).format('ddd Do MMM HH:mm')
}

const ValueLabelComponent = (props) => {
  const { children, open, value } = props

  const popperRef = React.useRef(null)
  React.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.update()
    }
  })

  return (
    <Tooltip
      PopperProps={{
        popperRef,
      }}
      open={open}
      enterTouchDelay={0}
      placement="top"
      title={value}
    >
      {children}
    </Tooltip>
  )
}

const computeMarks = (startUnix) => {
  const marks = []
  for (let index = 0; index <= 3; index += 1) {
    const date = moment.unix(startUnix).add(index, 'days').minute(0).second(0)
    marks[index] = {
      value: date.unix(),
      label: date.format('dddd'),
    }
  }
  return marks
}

const buildPlaceholderProps = () => {
  const startUnix = moment().startOf('hour').unix()
  const endUnix = moment().startOf('hour').add(3, 'days').unix()
  return {
    min: startUnix,
    max: endUnix,
    defaultValue: startUnix,
    marks: computeMarks(startUnix),
  }
}

function View({ forecastStartTimes, isFetchForecastsLoading, isLoadingSlider, onSliderValueChange }) {
  const hasData = forecastStartTimes && forecastStartTimes.length > 0

  const sliderProps = hasData
    ? {
        min: moment(head(forecastStartTimes)).unix(),
        max: moment(last(forecastStartTimes)).unix(),
        defaultValue: moment(head(forecastStartTimes)).unix(),
        marks: computeMarks(moment(head(forecastStartTimes)).unix()),
      }
    : buildPlaceholderProps()

  if (isFetchForecastsLoading) return <StyledLinearProgress />

  return (
    <StyledSlider
      className="slider-forecasts"
      defaultValue={sliderProps.defaultValue}
      valueLabelDisplay="auto"
      valueLabelFormat={sliderValueText}
      onChange={hasData ? onSliderValueChange : undefined}
      step={3600}
      marks={sliderProps.marks}
      min={sliderProps.min}
      max={sliderProps.max}
      ValueLabelComponent={ValueLabelComponent}
      disabled={!hasData}
    />
  )
}

const ForecastSliderView = deepMemo(View)

export { ForecastSliderView }
